/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ayush's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Ayush kumar's Portfolio",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Ayush kumar",
  logo_name: "Ayush kumar",
  subTitle:
    "MERN stack developer, Deep learning , AI, Machine Learning..Bringing ideas to life, one line of code at a time.",
  resumeLink:
    "https://drive.google.com/file/d/1mxO4ugoHJNsXUHsV_IndbXvp5n65L_KI/view?usp=sharing",
  portfolio_repository: "https://github.com/code1ayush/My-Portfoilio",
  githubProfile: "https://github.com/code1ayush",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/code1ayush",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ayush-kumar-8ab36b1a1/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:ayushverma8900@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/ayushkumar_18_/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Deep learning & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly accurate various deeplearning and statistical models",
        "⚡ Experience of working with Computer Vision and NLP projects",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React, and NodeJS for the backend",
        "⚡ Developing web applications using MERN stack ,Tailwind css",
        "⚡ Creating application backend in NodeJS",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "fa-code-fork",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Database",
          fontAwesomeClassname: "fa-database",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/codeayush/",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ayushkumar_18",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/code_ayush_",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/ayushkumar243",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "National institute of technology, Rourkela",
      subtitle: "B.Tech. in electronics and communication engineering",
      logo_path: "NITRKL.png",
      alt_name: "NIT Rourkela",
      duration: "2021 - 2025",
      descriptions: [
        "⚡ I have studied basic Electronics and communication engineering subjects like DSP, DIP, Microprocessor and MATLAB",
        "⚡ Apart from this, I have done courses on Deep Learning, and Full Stack Development.",
        "⚡ Other than this i have a good grasp of Data Structures and Algorithms",
      ],
      website_link: "https://www.nitrkl.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://www.nitrkl.ac.in/",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "John smilga",
      logo_path: "coursera_logo.png",
      certificate_link: "https://www.nitrkl.ac.in/",
      alt_name: "udemy",
      color_code: "#2A73CC",
    },

    {
      title: "Hackathon ",
      subtitle: "Winner",
      logo_path: "thacks.png",
      certificate_link:
        "https://drive.google.com/file/d/1sN5lqhYSP90EA8KN6yR3We3oZuL1rsmT/view?usp=sharing",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work",
  description:
    "I have a proven track record in web development and deep learning, collaborating with my college's web development club and leading successful teams in hackathons, resulting in victories.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Technical Team Member",
          company: "webwiz",
          company_url: "https://webwiznitr.netlify.app/",
          logo_path: "webwiz.jpg",
          duration: "Dec 2021 - Present",
          location: "Rourkela,Odisha",
          description:
            "I am working as a technical team member in webwiz, a web development club of NIT Rourkela. I am working on various projects and learning new technologies.As a technical team member of my college club, I play a crucial role in website development, contributing my skills to create dynamic and user-friendly online platforms. From designing and coding to ensuring functionality, I collaborate with fellow team members to build websites for our club and provide assistance to others seeking web solutions",
          color: "#0879bf",
        },
        {
          title: "Organizer",
          company: "hackodisha 3.0",
          company_url: "https://www.hackodisha.tech/",
          logo_path: "hack.jpg",
          duration: "sep 2023 - Oct 2023",
          location: "Rourkela, Odisha",
          description:
            "As an organizer for Hackodisha 3.0, I played a pivotal role in developing the event's websites, employing my technical skills in HTML, CSS, and JavaScript. My contributions went beyond coding, as I actively participated in various aspects, ensuring the overall success of the event. I played a key role in making Hackodisha 3.0 a resounding success.",
          color: "#9b1578",
        },
        {
          title: "Web developer",
          company: "SAC",
          company_url: "https://project-rose-lyart.vercel.app/",
          logo_path: "NITRKL.png",
          duration: "Dec 2022 - Feb 2023",
          location: "Rourkela, Odisha",
          description:
            "As the lead contributor for our college’s student activity center website, I played a critical role in creating a valuable resource for students to access information on upcoming events, college fests, clubs, and societies. Through my contributions, the web‐ site became a go‐to source for students seeking information about college activities and events",
          color: "#fc1f20",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile2.jpg",
    description:
      "I am available on almost every social media. You can message me. I can help you with Deep Learning, AI and MERN Stack Developement.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle: "Adil Nagar, Tedhipulia, Lucknow, U.P. 226022",
    locality: "Kanodar",
    country: "IN",
    region: "Lucknow",
    postalCode: "226022",
    streetAddress: "tedhipulia",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/d/viewer?mid=1PRNsTVTx_mxFS944bTNCFZldOoI&hl=en&ll=26.852253999999988%2C80.916367&z=17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
